var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1303 43.5553H81.156C92.9432 43.5553 102.5 52.9033 102.5 64.433V89.1224C102.5 100.652 92.9432 110 81.156 110H38.8389C27.0568 110 17.5 100.652 17.5 89.1224V64.433C17.5 54.9508 24.0033 47.0341 32.8539 44.4896L32.3001 44.5542V36.9357C32.4017 22.0813 44.7528 10 59.8933 10C71.7313 10 82.1925 17.3104 86.0538 28.1394C86.4603 29.2327 86.3586 30.4254 85.8506 31.469C85.3425 32.5127 84.4331 33.3078 83.3102 33.6607C81.0239 34.4508 78.4836 33.2631 77.6198 30.977C75.0287 23.6169 67.9208 18.6969 59.9949 18.6969C49.6252 18.6969 41.2472 26.8522 41.1913 36.8363V43.5454L41.1303 43.5553ZM59.9746 86.6425C62.4641 86.6425 64.4456 84.7043 64.4456 82.2692V71.2365C64.4456 68.851 62.4641 66.9128 59.9746 66.9128C57.5359 66.9128 55.5544 68.851 55.5544 71.2365V82.2692C55.5544 84.7043 57.5359 86.6425 59.9746 86.6425Z",
    fill: "#050C33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.331d1a8df80f1e330fe2b9e7ab52cb87.svg";
export { ForwardRef as ReactComponent };